<template>
  <e-btn v-if="$vuetify.display.mdAndUp" :variant="props.active ? 'tonal' : 'ghost'" prepend-icon-src="table">
    Таблица ограничений
  </e-btn>
</template>

<script setup lang="ts">
import { EBtn } from '@/core/components/ui';

const props = defineProps<{
  active: boolean;
}>();
</script>
